<template>
  <div class="bets">
    <info-box v-bind:description="description"></info-box>
    <header-title v-bind:title_img_src="title_img" />
    <nav-bar></nav-bar>
    <transition-group v-bind:name="gotInitialBets > 1 ? 'bets-list' : ''" mode="out-in">
      <bet v-for="betId in currentBetIds" v-bind:betId="betId" :key="betId"></bet>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'bets',
  async created () {
    await this.refreshBets()
  },
  data () {
    return {
      title_img: 'bets-title.svg',
      gotInitialBets: 0,
      description: {
        title: 'Bets',
        text: `When a bet is open It will be displayed here, If you want to place a bet just click on the bet and enter an amount then choose an option and click "Place Bet", Subscribers can bet on half of the options, non-subscribers can only bet on a single option. If you want to bet in chat, type your choice followed by the amount to bet. For example, Win 1000. Type !info to see your point balance, you get more for watching`
      }
    }
  },
  computed: Object.assign(mapState([
    'bets',
    'currentBetIds'
  ]), {

  }),
  watch: {
    currentBetIds: function () {
      this.gotInitialBets += 1
    }
  },
  methods: {
    async refreshBets () {
      this.$store.dispatch('fetchCurrentBets')
    }
  }
}
</script>

<style scoped>
.bets-list-enter-active,
.bets-list-leave-active {
  transition: background-color 0.3s;
}
.bets-list-enter,
.bets-list-leave-to {
  background-color: #fcc9fc;
}
</style>


// WEBPACK FOOTER //
// src/components/Bets.vue